<template>
    <div class='statement' v-show='!flag' @click='toStatementsDetail'>
        <div class='red'>
            <span>待支付</span>
            <span>¥{{detail.realAmount}}</span>
        </div>

        <div class='dero'>
            <span>请尽快完成支付或取消后重新结算</span>
            <span>查看明细</span>
        </div>   
        <img src="/images/public/arrow_right.png">
    </div>
</template>

<script>
    import orderApi from '@/axios/order'
    export default {
        name: 'statements',
        data () {
            return {
                detail : {},
                flag : true
            }
        },
        created () {
            this.getstatements();
        },
        methods: {
            toStatementsDetail(){
                if(this.detail.tradeType == 40){
                    this.$router.push({name:'statementsDetail',query:{code:this.detail.settlementCode,type:'active'}})
                }else{
                    this.$router.push({name:'statementsDetail',query:{code:this.detail.settlementCode}})
                }
                
            },
            getstatements(){
                orderApi.unpaid().then((res)=>{
                    console.log(res)
                    if(!res){
                        this.flag = true
                        return;
                    }
                    this.flag = false
                    this.detail = res;

                })
            }
        },
    
    }
</script>

<style scoped lang="scss">
    .statement{
        height: 120px;
        background: #fff;
        padding-left: 40px;
        padding-right: 70px;
        padding-top: 20px;
        box-shadow:0px -1px 10px 0px rgba(0,0,0,0.06);
        position: relative;
        &>div{
            display: flex;
            justify-content: space-between;
            line-height: 50px;
        }
        .red{
            // margin-top: 20px;
            font-size: 30px;
            color:#F56D6D;
            font-weight: 500;
        }
        .dero{
            color:#999999;
            font-size: 20px;
        }
        img{
            position: absolute;
            top:60px;
            right: 40px;
            width: 15px;
        }
    }
</style>
